import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Linkedin, Github, Mail, BookOpen, MapPin } from 'lucide-react';
import { profile } from '../data/portfolio';
import MetaBar from '../components/MetaBar';

const Home = () => {
  return (
    <div className="relative">
      <section className="relative glow-bg">
        <div className="max-w-3xl mx-auto px-6 pt-16 md:pt-24 pb-10 relative z-10">
          <div className="dot-eyebrow mono uppercase tracking-[0.2em] text-[11px] text-ink-mute mb-8 fade-up">
            {profile.role} · {profile.discipline}
          </div>

          <h1 className="text-[32px] sm:text-4xl md:text-5xl leading-[1.02] tracking-tight font-medium fade-up">
            {profile.headlineLead}
          </h1>

          {profile.stats && (
            <div className="dot-eyebrow mono uppercase tracking-[0.2em] text-[11px] text-ink-mute mt-8 mb-8 fade-up">
              {profile.stats.join('  ·  ')}
            </div>
          )}

          <div className="space-y-5 text-[16px] leading-[1.75] text-ink-soft max-w-2xl fade-up">
            <p>{profile.intro1}</p>
            <p>
              I've had the privilege of leading engineering teams and delivering resilient platforms for some of the
              world's leading financial institutions, including{' '}
              <span className="text-foreground font-medium">JPMorgan Chase, Deutsche Bank, UBS, and RBS</span>. My
              focus spans Site Reliability Engineering, Platform Engineering, Observability, IT Application
              Operations, Cloud, and FinOps.
            </p>
            <p>
              I'm currently taking a deliberate career break after my most recent role as{' '}
              <span className="text-foreground font-medium">Vice President — SRE at JPMorgan Chase</span>. I'm
              treating this time as structured, full-time work: certifications, hands-on AI and cloud projects,
              technical writing, and wide reading — while I explore the next VP / Head of SRE & Platform Engineering
              opportunity.{' '}
              <span className="text-brand font-medium">Available immediately for the right role.</span>
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3 mt-9 fade-up">
            <Link
              to="/experience"
              className="inline-flex items-center gap-2 h-11 pl-5 pr-4 rounded-lg bg-brand text-black font-medium text-[14px] hover:bg-brand-2 hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              View Leadership Impact <ArrowRight size={16} />
            </Link>
            <a
              href={profile.socials.emailResume}
              className="inline-flex items-center gap-2 h-11 px-5 rounded-lg border border-border text-[14px] hover:bg-brand/10 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              Request Resume
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-lg border border-border text-[14px] hover:bg-brand/10 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              Executive Contact
            </Link>
          </div>

          <div className="flex items-center gap-3 mt-10 fade-up">
            {[
              { i: Linkedin, h: profile.socials.linkedin },
              { i: Github, h: profile.socials.github },
              { i: BookOpen, h: profile.socials.goodreads },
              { i: Mail, h: profile.socials.email }
            ].map((l, idx) => (
              <a
                key={idx}
                href={l.h}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-lg border border-border flex items-center justify-center text-ink-soft hover:text-foreground hover:bg-brand/10 hover:border-brand/60 hover:shadow-md hover:-translate-y-0.5 transition-all"
              >
                <l.i size={16} />
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2 mt-8 text-[12px] mono uppercase tracking-widest text-ink-mute fade-up">
            <MapPin size={13} className="text-brand" /> {profile.location}
            <span className="mx-1">·</span> Ex {profile.companies.join(' · ')}
          </div>
        </div>
      </section>

      <MetaBar />
    </div>
  );
};

export default Home;
